module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/gears-static.f965050a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/gears-static.png
// module id = 3307
// module chunks = 11